import classnames from 'classnames/bind';
import { getItemCaption } from '../../utils/getItemCaption';
import styles from './IconWithCaption.module.scss';

const classNameBuilder = classnames.bind(styles);

export const IconWithCaption = ({
    item: { icon, badgeComponent: BadgeComponent, ...restItem },
    active,
    collapsed,
    onClick,
    className,
    showHintOnActive,
    dataAutomationId,
    ariaLabel,
    stateful = false,
}) => {
    const captionContent = getItemCaption(restItem);

    return (
        <div
            className={classNameBuilder('container', className, { active, collapsed })}
            onClick={onClick}
            data-automation={dataAutomationId}
            aria-label={ariaLabel}
        >
            <div className={styles['icon']}>
                {icon}
                <div className={styles['badge']}>{BadgeComponent && <BadgeComponent />}</div>
                {collapsed && (!active || showHintOnActive) && stateful && (
                    <div className={styles['icon-popup-spacer']}>
                        <div className={styles['icon-popup']}>{captionContent}</div>
                    </div>
                )}
            </div>
            <div className={styles['caption']}>{captionContent}</div>
        </div>
    );
};
